import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h
import KendoMenuMixin from './KendoMenuMixin'

export default {
    name: 'kendo-menu',
    mixins: [ KendoMenuMixin ],
    setup() {
        const v3 = !!gh
        return {
            v3
        }
    },
    render(createElement) {
        const h = gh || createElement
        const defaultSlot = (this.v3 && this.$slots.default && (typeof this.$slots.default === 'function')) ? this.$slots.default() : this.$slots.default
        return h('ul', defaultSlot)
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-layout-vue-wrapper/src/KendoMenu/index.js